import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as fromUserActions from '../actions/users.action';

import { Observable, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { FirebaseService } from '../../services/firebase/firebase.service';

@Injectable()
export class UserEffects {

    constructor(
        private readonly action$: Actions,
        private readonly firebaseService: FirebaseService
    ) { }

    // Add User
    addUser$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromUserActions.AddUserAction),
        map((action) => ({ type: fromUserActions.ADD_USER_SUCCESS, data: action.data })),
        catchError(error => of({ type: fromUserActions.ADD_USER_FAIL, error: error }))
    ));

    // Delete User
    deleteUser$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromUserActions.DeleteUserAction),
        map(() => ({ type: fromUserActions.DELETE_USER_SUCCESS })),
        catchError(error => of({ type: fromUserActions.DELETE_USER_FAIL, error: error }))
    ));

    // Update User
    updateUser$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromUserActions.UpdateUserAction),
        switchMap(async ({ data }) => {
            await this.firebaseService.updateDoc('users', data.id!, data);
            return data;
        }),
        map((data) => ({ type: fromUserActions.UPDATE_USER_SUCCESS, data })),
        catchError(error => of({ type: fromUserActions.UPDATE_USER_FAIL, error: error }))
    ));
}